import { Preferences } from '@capacitor/preferences';

let migrationPromise;

const ensureMigrated = () => {
  if (!migrationPromise) {
    migrationPromise = Preferences.migrate();
  }
  return migrationPromise;
};

const setItem = async (key, value) => {
  await ensureMigrated();
  await Preferences.set({
    key,
    value,
  });
};

const getItem = async (key) => {
  await ensureMigrated();
  const { value } = await Preferences.get({ key });
  return value;
};

const removeItem = async (key) => {
  await ensureMigrated();
  await Preferences.remove({ key });
};

const key = async (nth) => {
  await ensureMigrated();
  const keys = await Preferences.keys();
  return nth && keys ? keys[nth] : keys;
};

const clear = async () => {
  await ensureMigrated();
  await Preferences.clear();
};

export { setItem, getItem, removeItem, key, clear };
